import type { DependencyList, EffectCallback } from 'react';
import { useEffect, useRef } from 'react';

export const useDebounceEffect = (callback: EffectCallback, deps: DependencyList, delay: number) => {
  const ref = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      callback();
      clearTimeout(ref.current);
    }, delay);
  }, [
    callback,
    delay,
    // TS can't verify whether we've passed the correct dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ...deps,
  ]);
};
